export default __webpack_public_path__ + "static/media/fitnessLife.f8a08d9c.jpeg";